// Giga One image system.
// Neutral asset names describing the imagery itself. No BODY/BRAIN taxonomy.
// Every image supports the single positioning: AGI integrated with a
// production-ready manufacturing body.

const BASE = "/img";

export const GIGA_IMAGES = {
  heroCleanroom: `${BASE}/hero_cleanroom.png`, // autonomous cleanroom corridor with robots
  pharmaLine: `${BASE}/pharma_line.png`, // automated vial/packaging line
  factoryFloor: `${BASE}/factory_floor.png`, // vast smart-factory floor
  darkFactoryArm: `${BASE}/dark_factory_arm.png`, // robot arm + vial chiaroscuro
  infrastructureCorridor: `${BASE}/infrastructure_corridor.png`, // brutalist industrial corridor
  systemsField: `${BASE}/systems_field.png`, // abstract orchestration field
};
